<template>
  <nav class="app-navbar">
    <ul
      class="app-navbar-list horizontal-flow"
      :class="{ 'hide-scroll': hideScroll, 'with-dot': withDot }"
    >
      <slot />
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'AppNavbar',

  props: {
    hideScroll: {
      type: Boolean,
      default: true,
    },

    withDot: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;
@use '@/styles/functions.scss' as *;

.app-navbar-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  overflow-x: auto;

  // &::after {
  //   content: '';
  //   padding-right: inherit;
  // }

  &.hide-scroll {
    &::-webkit-scrollbar {
      display: none;
    }
  }

  &.with-dot {
    > .app-navbar-item {
      &.active {
        &::after {
          $size: 7px;
          content: '';
          display: block;
          transform: translateX(-50%);
          width: $size;
          height: $size;
          background-color: currentColor;
          border-radius: 100%;
          position: absolute;
          left: 50%;
          bottom: 0;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
